// Version : 0.0.2
// Author : SATHISH
// LastEdit : NANDHAKUMAR
// MODFIED DATE: 5/12/2025
import ChangeMeetingActionTypes from './change-meeting-report.type';

/** ***************** GET CHANGE MEETING DETAILS START *********************** */
export const getChangeMeetingDetailsStart = (getData: any) => ({
	type: ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_START,
	payload: getData,
});

export const getChangeMeetingDetailsSuccess = (successData: any) => ({
	type: ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_SUCCESS,
	payload: successData,
});

export const getChangeMeetingDetailsFailure = (failureData: any) => ({
	type: ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_FAILURE,
	payload: failureData,
});

export const getChangeMeetingDetailsResponseResetStart = () => ({
	type: ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_RESPONSE_RESET,
});

export const getChangeMeetingDetailsResponseChanged = () => ({
	type: ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_RESPONSE_CHANGED,
});
/** ***************** GET CHANGE MEETING DETAILS END *********************** */
